import { Injectable } from '@angular/core';
import { CachingHttpService, SmartHttpService } from '@hrra/core';
import { UrlConfigService } from '@hrra/core';
import { Field } from '../models/enums/jobseeker-field-enum';
import { LocalDataStorageService } from '@hrra/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@hrra/core';
import { UrlConfigContainer } from 'src/app/core/url-config';
import {
  BasicOptionItem,
  EducationalInstitution,
  EducationalProgram,
  FileDownloadInfoViewModel,
  Jobseeker,
  JobseekerExtendedLocationPath,
  JobseekerSkillViewModel,
  Specialization,
  SkillAutoCompleteRequest,
  SkillAutoCompleteResult,
  SkillBaseTypeEnum,
  SkillListRequest,
  SkillListResult,
  SkillListItem,
} from '@hrra/common-models';
import { JobseekerFile } from 'libs/common-models/src/lib/models/jobseeker/jobseeker-file-model';
import { ResetPasswordModel } from '@hrra/common-models';
import { AdvancedIndustryItem } from 'src/app/announcement/shared/models/industry-model';
import { IndustryListItem } from 'src/app/shared/models/industry-model';
import { JobseekerExtendedLocationModel } from 'src/app/shared/models/jobseeker-location.model';

@Injectable({
  providedIn: 'root',
})
export class JobseekerService {
  public cvExport() {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.urlConfig.api.data.jobseekers.cvExport,
      {}
    );
  }

  public getIndustryList() {
    return this.smartHttp.get<IndustryListItem[]>(
      this.urlService.urlConfig.api.data.industry.getIndustryList, {}
    )
  }

  public getSpecializationList(){
    return this.smartHttp.get<Specialization[]>(
      this.urlService.urlConfig.api.data.specialization.getSpecializationList, {}
    );
  }

  public getJobseeker() {
    return this.smartHttp.get<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.get,
      {}
    );
  }

  public getJobseekerForAdmin(jobseekerId: number){
    return this.smartHttp.get<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.get,{ jobseekerId }
    )
  }

  public getJobseekerLookup() {
    return this.cachingHttp.get<JobseekerLookupData>(
      this.urlService.urlConfig.api.data.lookup.jobseekerLookup,
      {}
    );
  }

  public getJobseekerSubscriptionLookup() {
    return this.smartHttp.post<JobseekerLookupViewModel>(
      this.urlService.urlConfig.api.data.jobseekers.jobseekerSubscriptionLookup,
      {}
    )
  }

  public unsubscribeJobseekerSubscription() {
    return this.smartHttp.post(
      this.urlService.urlConfig.api.data.jobseekers.subscription.unsubscribe,
      {}
    )
  }

  public downloadDocumentAttachment(jobseekerDocumentObjectId: string) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseekers.downloadDocument,
        { jobseekerDocumentObjectId: jobseekerDocumentObjectId }
      ),
      {}
    );
  }

  public downloadDocumentAttachmentFromAdmin(objectId: string, jobseekerId: number) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.admin.jobseeker.downloadDocument,
        { objectId, jobseekerId }
      ),
      {}
    );
  }

  public downloadLanguageAttachment(jobseekerLanguageObjectId: string) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseekers
          .downloadLanguageAttachment,
        { jobseekerLanguageId: jobseekerLanguageObjectId }
      ),
      {}
    );
  }

  public downloadLanguageAttachmentForAdmin(objectId: string, jobseekerId: number) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.admin.jobseeker.downloadLanguageAttachment,
        { objectId, jobseekerId }
      ),
      {}
    );
  }

  public downloadEducationAttachment(jobseekerEducationObjectId: string) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseekers
          .downloadEducationAttachment,
        { jobseekerEducationId: jobseekerEducationObjectId }
      ),
      {}
    );
  };

  public downloadEducationAttachmentFromAdmin(objectId: string, jobseekerId: number) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.admin.jobseeker.downloadEducationAttachment,
        { objectId, jobseekerId }
      ),
      {}
    );
  };

  public downloadExperienceAttachment(experienceId: string) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseekers
          .downloadExperienceAttachment,
        { experienceId }
      ),
      {}
    );
  }

  public downloadExperienceAttachmentFromAdmin(experienceId: string, jobseekerId: number) {
    return this.smartHttp.get<FileDownloadInfoViewModel>(
      this.urlService.format(
        this.urlService.urlConfig.api.data.admin.jobseeker.downloadExperienceAttachment,
        { experienceId, jobseekerId }
      ),
      {}
    );
  }

  public deleteJobseekerDocument(documentId: number, moderationLastChangeDate: Date, objectId: string) {
    let data = {
      Field: Field.Document,
      JobseekerSubmitData: {
        Document: {
          JobseekerDocumentId: documentId,
          IsDeleted: true,
          ObjectId: objectId
        },
        ModerationLastChangeDate:moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.get,
      data
    );
  }


  public deleteJobseekerDocumentForAdmin(documentId: string, objectId: string, jobseekerId: number, moderationLastChangeDate: Date,) {
    let data = {
      Field: Field.Document,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        Document: {
          JobseekerDocumentId: documentId,
          IsDeleted: true,
          ObjectId: objectId
        },
        ModerationLastChangeDate:moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public deleteJobseekerLanguage(languageId: number, moderationLastChangeDate:Date, objectId:string) {
    let data = {
      Field: Field.Language,
      JobseekerSubmitData: {
        Language: {
          JobseekerLanguageId: languageId,
          IsDeleted: true,
          ObjectId: objectId
        },
        ModerationLastChangeDate:moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.get,
      data
    );
  }

  public deleteJobseekerLanguageForAdmin(languageId: number, objectId:string, jobseekerId: number, moderationLastChangeDate: Date) {
    let data = {
      Field: Field.Language,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        Language: {
          JobseekerLanguageId: languageId,
          IsDeleted: true,
          ObjectId: objectId
        },
        ModerationLastChangeDate:moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public deleteJobseekerWorkExperience(experienceId: string, objectId:string, moderationLastChangeDate:Date) {
    let data = {
      Field: Field.WorkExperience,
      JobseekerSubmitData: {
        Experience: {
          JobseekerWorkExperienceId: experienceId,
          IsDeleted: true,
        },
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.get,
      data
    );
  }

  public deleteJobseekerWorkExperienceForAdmin(experienceId: string, jobseekerId: number, moderationLastChangeDate:Date) {
    let data = {
      Field: Field.WorkExperience,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        Experience: {
          JobseekerWorkExperienceId: experienceId,
          IsDeleted: true,
        },
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public deleteJobseekerEducation(educationId: number, moderationLastChangeDate:Date, objectId:string) {
    let data = {
      Field: Field.Education,
      JobseekerSubmitData: {
        Education: {
          JobseekerEducationId: educationId,
          IsDeleted: true,
          ObjectId: objectId
        },
        ModerationLastChangeDate:moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.get,
      data
    );
  }

  public deleteJobseekerEducationnForAdmin(educationId: number, objectId:string, jobseekerId: number, moderationLastChangeDate: Date) {
    let data = {
      Field: Field.Education,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        Education: {
          JobseekerEducationId: educationId,
          IsDeleted: true,
          ObjectId: objectId
        },
        ModerationLastChangeDate:moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  //photo
  public deleteJobseekerPhoto(moderationLastChangeDate:Date) {
    let data = {
      Field: Field.Photo,
      JobseekerSubmitData: {
        Photo: {
          IsDeleted: true,
        },
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public deleteJobseekerPhotoFromAdmin(jobseekerId: number, moderationLastChangeDate:Date) {
    let data = {
      Field: Field.Photo,
      JobseekerSubmitData: {
        Photo: {
          IsDeleted: true,
        },
        ModerationLastChangeDate: moderationLastChangeDate,
        JobseekerId: jobseekerId
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public editJobseekerPhoto(imageBase64: string, moderationLastChangeDate:Date) {
    let data = {
      Field: Field.Photo,
      JobseekerSubmitData: {
        Photo: {
          ImageBase64: imageBase64,
        },
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public editJobseekerPhotoForAdmin(imageBase64: string, moderationLastChangeDate: Date, jobseekerId: number) {
    let data = {
      Field: Field.Photo,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        Photo: {
          ImageBase64: imageBase64,
        },
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public editJobseekerPersonalInfo(personalInfo: JobseekerPersonalInfoModel, moderationLastChangeDate:Date) {
    let month =
      personalInfo.birthMonth < 10
        ? '0' + personalInfo.birthMonth
        : personalInfo.birthMonth;
    let day =
      personalInfo.birthDay < 10
        ? '0' + personalInfo.birthDay
        : personalInfo.birthDay;

    let data = {
      Field: Field.PersonalInfo,
      JobseekerSubmitData: {
        Name: personalInfo.name,
        Surname: personalInfo.surname,
        DateOfBirth: personalInfo.birthYear + '-' + month + '-' + day,
        City: personalInfo.city,
        Gender: personalInfo.gender,
        Address: personalInfo.address,
        LegalAddress: personalInfo.legalAddress,
        SameAsCurrentAddress: personalInfo.sameAsCurrentAddress,
        Email: personalInfo.email,
        Phone: personalInfo.phone,
        Phone2: personalInfo.phone2,
        DrivingLicenses: personalInfo.drivingLicenses,
        IsVehicleOwner: personalInfo.ownVehicle,
        ExtendedLocationId: personalInfo.extendedLocationId,
        JobseekerVehicles: personalInfo.jobseekerVehicles,
        ModerationLastChangeDate: moderationLastChangeDate,
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public editJobseekerPersonalInfoForAdmin(personalInfo: JobseekerPersonalInfoModel, moderationLastChangeDate:Date) {
    let month =
      personalInfo.birthMonth < 10
        ? '0' + personalInfo.birthMonth
        : personalInfo.birthMonth;
    let day =
      personalInfo.birthDay < 10
        ? '0' + personalInfo.birthDay
        : personalInfo.birthDay;

    let data = {
      Field: Field.PersonalInfo,
      JobseekerSubmitData: {
        JobseekerId: personalInfo.jobseekerId,
        Name: personalInfo.name,
        Surname: personalInfo.surname,
        DateOfBirth: personalInfo.birthYear + '-' + month + '-' + day,
        City: personalInfo.city,
        Gender: personalInfo.gender,
        Address: personalInfo.address,
        LegalAddress: personalInfo.legalAddress,
        SameAsCurrentAddress: personalInfo.sameAsCurrentAddress,
        Email: personalInfo.email,
        Phone: personalInfo.phone,
        Phone2: personalInfo.phone2,
        DrivingLicenses: personalInfo.drivingLicenses,
        IsVehicleOwner: personalInfo.ownVehicle,
        ExtendedLocationId: personalInfo.extendedLocationId,
        JobseekerVehicles: personalInfo.jobseekerVehicles,
        ModerationLastChangeDate: moderationLastChangeDate,
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public validateEmail(
    email: string
  ): Observable<
    ApiResponse<ServerValidationResult<JobseekerRegistrationValidationMessage>>
  > {
    return this.smartHttp.get(
      this.urlService.urlConfig.api.data.jobseekers.validateEmail,
      { email: email }
    )
  }

  public register(registrationRequest: JobseekerRegistrationRequestViewModel) {
    return this.smartHttp.post<JobseekerRegsitrationResponseViewModel>(
      this.urlService.urlConfig.api.data.jobseekers.register,
      registrationRequest
    );
  }

  public resendVerificationEmail(emailVerificationResendToken: string) {
    let data = { EmailVerificationResendToken: emailVerificationResendToken };

    return this.smartHttp.post(
      this.urlService.urlConfig.api.data.jobseekers.resendActivationEmail,
      data
    );
  }

  public verifyEmail(verificationCode: string) {
    let data = { VerificationCode: verificationCode };

    return this.smartHttp.post(
      this.urlService.urlConfig.api.data.jobseekers.verifyEmail,
      data
    );
  }

  public editJobseekerEducation(education: JobseekerEducationModel, moderationLastChangeDate: Date) {
    let data: any;

    let jobseekerEducation: any = {
      EducationLevelId: education.educationLevelId,
      EducationalInstitutionId: education.educationalInstitutionId,
      EducationalProgramId: education.educationalProgramId,
      EducationalProgramName: education.educationalProgramName,
      Institution: education.institution,
      Specialization: education.specialization,
      DateFromYear: Number(education.dateFromYear),
      DateFromMonth: education.dateFromMonth,
      DateToYear: Number(education.dateToYear),
      DateToMonth: education.dateToMonth,
      Description: education.description,
      ObjectId: education.objectId
    };

    if (education.jobseekerEducationId != null) {
      jobseekerEducation.jobseekerEducationId = education.jobseekerEducationId;
    }

    if (education.fileName != null) {
      jobseekerEducation.Attachment = {
        Filename: education.fileName,
      };
    }

    data = {
      Field: Field.Education,
      JobseekerSubmitData: {
        Education: jobseekerEducation,
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public editJobseekerEducationForAdmin(education: JobseekerEducationModel, moderationLastChangeDate: Date, jobseekerId: number) {
    let data: any;

    let jobseekerEducation: any = {
      EducationLevelId: education.educationLevelId,
      EducationalInstitutionId: education.educationalInstitutionId,
      EducationalProgramId: education.educationalProgramId,
      EducationalProgramName: education.educationalProgramName,
      Institution: education.institution,
      Specialization: education.specialization,
      DateFromYear: Number(education.dateFromYear),
      DateFromMonth: education.dateFromMonth,
      DateToYear: Number(education.dateToYear),
      DateToMonth: education.dateToMonth,
      Description: education.description,
      ObjectId: education.objectId
    };

    if (education.jobseekerEducationId != null) {
      jobseekerEducation.jobseekerEducationId = education.jobseekerEducationId;
    }

    if (education.fileName != null) {
      jobseekerEducation.Attachment = {
        Filename: education.fileName,
      };
    }

    data = {
      Field: Field.Education,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        Education: jobseekerEducation,
        moderationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public uploadTempFile(data: FormData) {
    let headers = new HttpHeaders();

    if (this.storage.hasAccessToken()) {
      headers = headers.append(
        'Authorization',
        `Bearer ${this.storage.getAccessToken()}`
      );
    }

    return this.http.post<any>(
      this.urlService.urlConfig.api.data.jobseekers.uploadTempFile,
      data,
      { headers: headers }
    );
  }

  public uploadTempFileForAdmin(data: FormData) {
    let headers = new HttpHeaders();

    if (this.storage.hasAccessToken()) {
      headers = headers.append(
        'Authorization',
        `Bearer ${this.storage.getAccessToken()}`
      );
    }

    return this.http.post<any>(
      this.urlService.urlConfig.api.data.admin.jobseeker.document.uploadTemp,
      data,
      { headers: headers }
    );
  }

  public editJobseekerLanguage(language: JobseekerLanguageModel, moderationLastChangeDate:Date) {
    let data: any;

    let jobseekerLanguage: any = {
      WorldLanguageId: language.worldLanguageId,
      LanguageProficiencyLevelId: language.languageProficiencyLevelId,
      ObjectId: language.objectId,
    };

    if (language.jobseekerLanguageId != null) {
      jobseekerLanguage.JobseekerLanguageId = language.jobseekerLanguageId;
    }

    if (language.fileName != null) {
      jobseekerLanguage.Attachment = {
        Filename: language.fileName,
      };
    }

    data = {
      Field: Field.Language,
      JobseekerSubmitData: {
        Language: jobseekerLanguage,
        ModerationLastChangeDate:moderationLastChangeDate
      },
    };
    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public editJobseekerLanguageForAdmin(language: JobseekerLanguageModel, jobseekerId: number, moderationLastChangeDate: Date) {
    let data: any;

    let jobseekerLanguage: any = {
      WorldLanguageId: language.worldLanguageId,
      LanguageProficiencyLevelId: language.languageProficiencyLevelId,
      ObjectId: language.objectId,
    };

    if (language.jobseekerLanguageId != null) {
      jobseekerLanguage.JobseekerLanguageId = language.jobseekerLanguageId;
    }

    if (language.fileName != null) {
      jobseekerLanguage.Attachment = {
        Filename: language.fileName,
      };
    }

    data = {
      Field: Field.Language,
      JobseekerSubmitData: {
        Language: jobseekerLanguage,
        JobseekerId : jobseekerId,
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };
    
    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public uploadJobseekerDocument(document: JobseekerDocumentViewModel, moderationLastChangeDate:Date) {
    let data = {
      Field: Field.Document,
      JobseekerSubmitData: {
        Document: {
          DocumentTypeId: document.documentTypeId,
          Description: document.comment,
          FileName: document.fileName,
        },
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public uploadJobseekerDocumentForAdmin(document: JobseekerDocumentViewModel, jobseekerId: number, moderationLastChangeDate: Date) {
    let data = {
      Field: Field.Document,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        ModerationLastChangeDate: moderationLastChangeDate,
        Document: {
          DocumentTypeId: document.documentTypeId,
          Description: document.comment,
          FileName: document.fileName,
        },
      },
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public editJobseekerWorkExperience(workExperience: JobseekerWorkExperienceModel, jobseekerId: number, moderationLastChangeDate: Date) {
    let data: any;

    let jobseekerWorkExperience: any = {
      JobseekerWorkExperienceId: workExperience.jobseekerWorkExperienceId,
      JobseekerId: jobseekerId,
      DateFromMonth: workExperience.dateFromMonth,
      DateFromYear: +workExperience.dateFromYear,
      DateToMonth: workExperience.dateToMonth,
      DateToYear: !workExperience.isCurrent ? +workExperience.dateToYear : null,
      IsCurrent: workExperience.isCurrent,
      Employer: workExperience.employer,
      PositionTitle: workExperience.positionTitle,
      Description: workExperience.description,
      IsDeleted: false,
      Industries: workExperience.industries,
      ExtendedLocations: workExperience.extendedLocations?.map((v) => v.locationId),
      Specializations: workExperience.specializations,
      EmploymentFormId: workExperience.employmentFormId,
      EmploymentFormTypeId: workExperience.employmentTypeId,
      WorkScheduleId: workExperience.workScheduleId,
      SeniorityLevelId: workExperience.seniorityLevelId,
    };

    if (workExperience.jobseekerWorkExperienceId != null) {
      jobseekerWorkExperience.JobseekerWorkExperienceId =
        workExperience.jobseekerWorkExperienceId;
    }
    if (workExperience.fileName != null) {
      jobseekerWorkExperience.Attachment = {
        Filename: workExperience.fileName,
      };
    }

    data = {
      Field: Field.WorkExperience,
      JobseekerSubmitData: {
        Experience: jobseekerWorkExperience,
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };
    
    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public editJobseekerWorkExperienceForAdmin(workExperience: JobseekerWorkExperienceModel, jobseekerId: number, moderationLastChangeDate: Date) {
    let data: any;

    let jobseekerWorkExperience: any = {
      JobseekerWorkExperienceId: workExperience.jobseekerWorkExperienceId,
      JobseekerId: jobseekerId,
      DateFromYear: +workExperience.dateFromYear,
      DateFromMonth: workExperience.dateFromMonth,
      DateToMonth: workExperience.dateToMonth,
      DateToYear: !workExperience.isCurrent ? +workExperience.dateToYear : null,
      IsCurrent: workExperience.isCurrent,
      Employer: workExperience.employer,
      PositionTitle: workExperience.positionTitle,
      Description: workExperience.description,
      IsDeleted: false,
      Industries: workExperience.industries,
      Specializations: workExperience.specializations,
      ExtendedLocations: workExperience.extendedLocations?.map((v) => v.locationId),
      EmploymentFormId: workExperience.employmentFormId,
      EmploymentFormTypeId: workExperience.employmentTypeId,
      WorkScheduleId: workExperience.workScheduleId,
      SeniorityLevelId: workExperience.seniorityLevelId,
    };

    if (workExperience.jobseekerWorkExperienceId != null) {
      jobseekerWorkExperience.JobseekerWorkExperienceId =
        workExperience.jobseekerWorkExperienceId;
    }
    if (workExperience.fileName != null) {
      jobseekerWorkExperience.Attachment = {
        Filename: workExperience.fileName,
      };
    }

    data = {
      Field: Field.WorkExperience,
      JobseekerSubmitData: {
        JobseekerId: jobseekerId,
        Experience: jobseekerWorkExperience,
        ModerationLastChangeDate: moderationLastChangeDate
      },
    };
    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public setIsWorkExperienceFilled(isWorkExperienceFilled: boolean, moderationLastChangeDate: Date) {
    let data: any;

    data = {
      Field: Field.IsWorkExperienceFilled,
      JobseekerSubmitData: {
        isWorkExperienceFilled: isWorkExperienceFilled,
        moderationLastChangeDate: moderationLastChangeDate
      },
    };
    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public setIsWorkExperienceFilledForAdmin(payload) {
    let data: any;

    data = {
      Field: Field.IsWorkExperienceFilled,
      JobseekerSubmitData: {
        isWorkExperienceFilled: payload.isWorkExperienceFilled,
        moderationLastChangeDate: payload.moderationLastChangeDate,
        jobseekerId: payload.jobseekerId
      },
    };
    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  public updateSubscription(
    subscription: JobseekerSubscriptionUpdateViewModel
  ) {
    return this.smartHttp.post<JobseekerSubscriptionViewModel>(
      this.urlService.urlConfig.api.data.jobseekers.subscription.edit,
      subscription
    );
  }

  public getSubscription() {
    return this.smartHttp.get<JobseekerSubscriptionViewModel>(
      this.urlService.urlConfig.api.data.jobseekers.subscription.get,
      {}
    );
  }

  public resetPassword(request: ResetPasswordModel) {
    return this.smartHttp.post(
      this.urlService.urlConfig.api.data.jobseekers.resetPassword,
      request
    );
  }

  public getSkillSuggestions(request: SkillAutoCompleteRequest) {
    return this.smartHttp.post<SkillAutoCompleteResult>(
      this.urlService.urlConfig.api.data.jobseekers.skillSuggestions,
      request
    );
  }

  public getSkillSuggestionsPublic(request: SkillAutoCompleteRequest) {
    return this.smartHttp.post<SkillAutoCompleteResult>(
      this.urlService.urlConfig.api.data.skills.skillSuggestions,
      request
    );
  }

  //resolves skill codes coming from the announcement search url back into skills with titles
  public getSkillListPublic(request: SkillListRequest) {
    return this.smartHttp.post<SkillListItem[]>(
      this.urlService.urlConfig.api.data.skills.skillList,
      request
    );
  }

  public saveJobseekerSkills(skills: JobseekerSkillViewModel[], skillBaseType: SkillBaseTypeEnum, moderationLastChangeDate: Date) {
    const skillSubmitData = skills.map((skill, index) => ({
      UserProvidedText: skill.name,
      CanonicalSkillId: skill.canonicalSkillId,
      Index: index,
    }));

    const data = {
      Field: skillBaseType === SkillBaseTypeEnum.Hard ? Field.HardSkill : Field.SoftSkill,
      JobseekerSubmitData:
        skillBaseType === SkillBaseTypeEnum.Hard
          ? { HardSkills: skillSubmitData, moderationLastChangeDate: moderationLastChangeDate }
          : { SoftSkills: skillSubmitData, moderationLastChangeDate: moderationLastChangeDate }
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.jobseekers.edit,
      data
    );
  }

  public saveJobseekerSkillsForAdmin(skills: JobseekerSkillViewModel[], skillBaseType: SkillBaseTypeEnum, jobseekerId: number, moderationLastChangeDate: Date) {
    const skillSubmitData = skills.map((skill, index) => ({
      UserProvidedText: skill.name,
      CanonicalSkillId: skill.canonicalSkillId,
      Index: index,
    }));

    const data = {
      Field: skillBaseType === SkillBaseTypeEnum.Hard ? Field.HardSkill : Field.SoftSkill,
      JobseekerSubmitData:
        skillBaseType === SkillBaseTypeEnum.Hard
          ? { HardSkills: skillSubmitData, JobseekerId: jobseekerId, ModerationLastChangeDate: moderationLastChangeDate }
          : { SoftSkills: skillSubmitData, JobseekerId: jobseekerId, ModerationLastChangeDate: moderationLastChangeDate }
    };

    return this.smartHttp.post<Jobseeker>(
      this.urlService.urlConfig.api.data.admin.jobseeker.save,
      data
    );
  }

  constructor(
    private smartHttp: SmartHttpService,
    private cachingHttp: CachingHttpService,
    private http: HttpClient,
    private urlService: UrlConfigService<UrlConfigContainer>,
    private storage: LocalDataStorageService
  ) {}
}

export interface JobseekerLookupData {
  jobseekerDrivingLicenses: BasicOptionItem[];
  genderList: BasicOptionItem[];
  drivingLicenceList: BasicOptionItem[];
  documentTypeList: BasicOptionItem[];
  worldLanguages: BasicOptionItem[];
  languageProficiencyLevels: BasicOptionItem[];
  educationLevels: BasicOptionItem[];
  educationalInstitutionsList: EducationalInstitution[];
  monthListFull: BasicOptionItem[];
  monthListShort: BasicOptionItem[];
  yearList: BasicOptionItem[];
  yearListBirth: BasicOptionItem[];
  jobseekerPrivacyList: BasicOptionItem[];
  vehicleTypes: BasicOptionItem[];
  educationProgramsList: EducationalProgram[];
}

export interface JobseekerPersonalInfoModel {
  jobseekerId: number;
  name: string;
  surname: string;
  email: string;
  phone: string;
  phone2: string;
  address: string;
  legalAddress: string;
  sameAsCurrentAddress: boolean;
  gender: number;
  city: number;
  drivingLicenses: number[];
  ownVehicle: boolean;
  birthMonth: number;
  birthYear: number;
  birthDay: number;
  extendedLocationPath: JobseekerExtendedLocationPath;
  extendedLocationId: string;
  jobseekerVehicles: number[];
  jobseekerExtendedLocations: string[];
}

export interface ServerValidationResult<T> {
  isSuccess: boolean;
  items: ServerValidationResultItem<T>;
}

export interface ServerValidationResultItem<T> {
  messageType: T;
  statusLevel: StatusLevel;
}

export enum StatusLevel {
  None,
  Info,
  Warning,
  Error,
}

export enum JobseekerRegistrationValidationMessage {
  EmailRegisteredButBelongsToCustomer,
  EmailRegisteredButJobseekerPending,
  EmailRegisteredToAccessYourAccountPleaseLogin,
  EmailRegisteredToSubscriber,
  SubscriberEmailRegisteredButBelongsToCustomer,

  CannotConnectToServer,
}

export interface JobseekerRegistrationRequestViewModel {
  Email: string;
  Password: string;
  Name: string;
  Surname: string;
  PhoneNumber: string;
  ReCaptchaToken: string;
  IsAgreementChecked: boolean;
}

export interface JobseekerRegsitrationResponseViewModel {
  emailVerificationResendToken: string;
}

export interface JobseekerEducationModel {
  jobseekerEducationId: number;
  educationLevelId: number;
  educationalInstitutionId?: number;
  educationalProgramId?: number;
  educationalProgramName: string;
  institution: string;
  specialization: string;
  dateFromYear: number;
  dateFromMonth: number;
  dateToYear: number;
  dateToMonth: number;
  description: string;
  fileName: string;
  attachment: JobseekerFile;
  objectId: string
}

export interface FileUploadResultViewModel {
  filename: string;
}

export interface JobseekerLanguageModel {
  jobseekerLanguageId: number;
  worldLanguageId: number;
  languageProficiencyLevelId: number;
  fileName: string;
  name: string;
  objectId: string
}

export interface JobseekerDocumentViewModel {
  documentTypeId: number;
  comment: string;
  fileName: string;
  objectId: string
}

export interface JobseekerWorkExperienceModel {
  experienceId: string;
  legacyJobseekerWorkExperienceId?: number;
  jobseekerWorkExperienceId: number;
  dateFromYear: number;
  dateFromMonth?: number;
  dateToYear?: number;
  dateToMonth?: number;
  isCurrent: boolean;
  employer: string;
  positionTitle: string;
  description: string;
  isLast?: boolean;
  createDate?: Date;
  fileName: string;
  specializations: string[];
  industries: string[];
  seniorityLevelId: string;
  employmentTypeId?: number;
  employmentFormId: string;
  workScheduleId: string;
  extendedLocations: JobseekerExtendedLocationModel[];
}

export interface JobseekerSubscriptionViewModel {
  specializations: JobseekerSpecializationViewModel[];
  locations: JobseekerLocationViewModel[];
  seniorityLevels: JobseekerSeniorityLevelViewModel[];
}

export interface JobseekerSubscriptionUpdateViewModel {
  SpecializationIds: string[];
  LocationIds: string[];
  SeniorityLevelIds: string[];
}

export interface JobseekerLookupViewModel {
  specializations: JobseekerSpecializationViewModel[];
  locations: JobseekerLocationViewModel[];
  seniorityLevels: JobseekerSeniorityLevelViewModel[];
}

export interface JobseekerLocationViewModel {
  id: string;
  name: string;
}

export interface JobseekerSeniorityLevelViewModel {
  id: string;
  name: string;
}

export interface JobseekerSpecializationViewModel {
  id: string;
  name: string;
}
